import {Pagination, PaginationParams, SimpleSearchPaginationParams} from "../core/services/utils";
import {http} from "../core/services/http";
import {IBook, INameId} from "../core/interfaces";
import {UUID} from "node:crypto";


export const getAllCategories = (params?: SimpleSearchPaginationParams) =>
    http.get<Pagination<INameId>>('/api/dashboard/categories', {
        params,
    })

export const createCategory = (data: INameId) =>
    http.post<INameId>('/api/dashboard/categories', data)

export const updateCategory = (id: UUID, data: INameId) =>
    http.put<INameId>(`/api/dashboard/categories/${id}`,  data )

export const deleteCategory = (id: UUID) =>
    http.delete(`/api/dashboard/categories/${id}`, {})

export const toggleCategoryCall = (id: UUID) =>
    http.post<INameId>(`/api/dashboard/categories/${id}/toggle-visibility`)